<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome, please login to your account.</p>
                </div>

                <div>
                  <vs-input
                    v-validate="'required|email|min:3'"
                    data-vv-validate-on="blur"
                    name="username"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="username"
                    class="w-full mt-10"
                    v-on:keyup.enter="loginJWT"
                  />
                  <span class="text-danger text-sm username-error">{{ errors.first('username') }}</span>

                  <vs-input
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full mt-10"
                    v-on:keyup.enter="loginJWT"
                  />
                  <span class="text-danger text-sm password-error">{{ errors.first('password') }}</span>

                  <div class="flex flex-wrap justify-end my-5">
                    <router-link to="/forgot-password"
                      >Forgot Password?</router-link
                    >
                  </div>
                  <vs-button class="login-button" :disabled="!validateForm" @click="loginJWT">Login</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import get from 'lodash.get'

export default {
  data() {
    return {
      username: "",
      password: "",
      prevRoute: null
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.username != "" && this.password != "";
    }
  },
  methods: {
    async loginJWT() {
      if (this.$store.getters['users/getUserToken']) {
        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        })
        return
      }
      // Loading
      this.$vs.loading()
      const payload = {
        username: this.username,
        password: this.password
      }
      try {
        await this.$store.dispatch("users/login", payload)
        if (!this.$store.getters['users/hasAccessRol']) {
          this.$store.dispatch("users/logout")
          throw "No role assigned"
        }
        this.$vs.loading.close()
        this.prevRoute ? window.location.assign(this.prevRoute) : this.$router.push({name: 'home'})
      } catch (error) {
        let errorAux = error
        if (!errorAux) {
          errorAux = {message: "Invalid username or password"}
        }
        this.$vs.loading.close()
        this.showError(errorAux)
      }
    }
  },
  mounted() {
    this.prevRoute = get(this.$route, 'query.redirect_url', null)
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
